import { Suspense, useEffect } from "react";
import { Footer, Preloader } from "@/components";
import { Topbar, Navbar } from "@/components/layout/admin";
import { useLanguageContext } from "../context/useLanguageContext";
import { useTranslation } from "react-i18next";

const AdminLayout = ({ children }) => {
  const { language } = useLanguageContext();
  const { i18n } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  useEffect(() => {
    changeLanguage(language);
  }, [language]);
  return (
    <Suspense>
      <Suspense>
        <Topbar />
      </Suspense>

      <Suspense>
        <Navbar />
      </Suspense>

      <Suspense fallback={<Preloader />}>{children}</Suspense>

      <Suspense>
        <Footer hideLinks />
      </Suspense>
    </Suspense>
  );
};

export default AdminLayout;
